__turbopack_context__.v({
  "adapted": "ChartLegend-module-scss-module__DmuRyG__adapted",
  "dashed": "ChartLegend-module-scss-module__DmuRyG__dashed",
  "inactive": "ChartLegend-module-scss-module__DmuRyG__inactive",
  "indicator": "ChartLegend-module-scss-module__DmuRyG__indicator",
  "legend": "ChartLegend-module-scss-module__DmuRyG__legend",
  "legend-item": "ChartLegend-module-scss-module__DmuRyG__legend-item",
  "line-indicator": "ChartLegend-module-scss-module__DmuRyG__line-indicator",
});
